export default "__VITE_ASSET__qdEIkFYp__"